import { useApiScope } from '../../scope';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { BASE_URL } from './helpers';
import { FormTemplateKeyResponse } from './types';

/**
 * Hook to fetch a single form template key by ID
 */
export const useFormTemplateKey = (keyId: string | null | undefined) => {
  const { shareToken } = useApiScope();
  const url = keyId ? `${BASE_URL}/${keyId}` : null;

  const { data, error, isLoading, mutate } = useSWR<FormTemplateKeyResponse>(
    url,
    SWRFetcher({
      method: 'GET',
      shareToken,
    })
  );

  return {
    data,
    error,
    isLoading,
    mutate,
    key: data?.formTemplateKey ?? null,
  };
};

